export default "__VITE_ASSET__BFn5HcvT__"